import React from 'react';
import PropTypes from 'prop-types';
import { Redirect } from 'react-router-dom';
import { WorkflowStepNames } from '../../../constants/constants';
import Routes from '../../../constants/routes';
import Notification from '../../Common/Notification';
import LoadingIndicator from '../../Common/LoadingIndicator/LoadingIndicator';
import * as types from '../../../constants/actionTypes';
import ResetPasswordForm from '../../ResetPassword/ResetPasswordForm';

class PasswordExpiredWorkflowStep extends React.Component {
    constructor(props, context) {
        super(props, context);
        this.state = {
            isLoading: false,
            oldPassword: {
                value: '',
                errors: []
            },
            password: {
                value: '',
                errors: []
            },
            confirm: {
                value: '',
                errors: []
            }
        };
    }

    onChange = (event) => {
        const name = event.currentTarget.name;
        const value = event.currentTarget.value;
        const errors = this.getFieldErrors(name, value);
        this.setState({ [event.currentTarget.name]: { ...this.state[name], value: value, errors: errors } });
    }

    getFieldErrors = (name, value) => {
        let errors = [];
        switch (name) {
            case 'oldPassword' : {
                if (value.length < 1) {
                    errors.push('Old Password is required');
                }
                break;
            }
            case 'password': {
                if (value.length < 1) {
                    errors.push('Password is required');
                }
                break;
            }
            case 'confirm': {
                const pass = this.state.password.value;
                if (value.length < 1) {
                    errors.push('Password confirmation is required');
                } else if (pass !== value) {
                    errors.push('Passwords do not match');
                }
                break;
            }
            default:
                break;
        }
        return errors;
    }

    isFormValid = () => {
        const oldPasswordErrors = this.getFieldErrors('oldPassword', this.state.oldPassword.value);
        if (oldPasswordErrors.length > 0) {
            this.setState({ oldPassword: { ...this.state.oldPassword, errors: oldPasswordErrors } });
        }
        const passwordErrors = this.getFieldErrors('password', this.state.password.value);
        if (passwordErrors.length > 0) {
            this.setState({ password: { ...this.state.password, errors: passwordErrors } });
        }
        const confirmErrors = this.getFieldErrors('confirm', this.state.confirm.value);
        if (confirmErrors.length > 0) {
            this.setState({ confirm: { ...this.state.confirm, errors: confirmErrors } });
        }
        return oldPasswordErrors.length <= 0 && passwordErrors.length <= 0 && confirmErrors.length <= 0;
    }

    resetPassword = (event) => {
        event.preventDefault();
        event.stopPropagation();

        if (!this.isFormValid()) {
            return;
        }

        this.props.actions.resetPassword(this.props.step.userKey, null, this.state.oldPassword.value, this.state.password.value, this.state.confirm.value)
            .then((result) => {
                if (result.type === types.RESET_PASSWORD_SUCCESS) {
                    Notification("success", "Password Reset Success", "Your password has been successsfully reset");
                    this.props.actions.completeWorkflowStep(this.props.step.name);
                } else if (result.type === types.RESET_PASSWORD_FAILURE) {
                    Notification("error", "Error", result.payload.message);
                }
            })
            .catch(error => {
                Notification("error", "Error", error);
            });
    }

    render() {
        if (!this.props.user || !this.props.step || this.props.step.name !== WorkflowStepNames.PasswordExpired) {
            Notification("error", "Error", "Invalid Step Name: Expected " + WorkflowStepNames.PasswordExpired + " Actual: " + this.props.step.name);
            return (<Redirect to={Routes.LoginPage} />);
        }


        return (
            <LoadingIndicator isLoading={this.state.isLoading} isFullscreen={false}>
                <ResetPasswordForm
                    title="It is time to change your password"
                    password={this.state.password}
                    confirm={this.state.confirm}
                    onSubmit={this.resetPassword}
                    onChange={this.onChange}
                    isTokenExpired={false}
                    isOldPasswordRequired={true}
                    oldPassword={this.state.oldPassword}
                />
            </LoadingIndicator>
        )
    }
}

PasswordExpiredWorkflowStep.propTypes = {
    step: PropTypes.object.isRequired,
    user: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired
};

export default PasswordExpiredWorkflowStep;